import { AnimatePresence } from 'framer-motion';
import { useEntryModalContext } from '@/pages/Schedule/components';
import { useDraftEntryStore } from '@/pages/Schedule/stores';
import { MotionFlex } from '@/ui';
import { RsvpBar } from '../../RsvpBar';

export const EntryModalRsvpBar = () => {
  const { activeSidebarPanel } = useEntryModalContext();
  const draftEntry = useDraftEntryStore((state) => state.draftEntry);

  return (
    <AnimatePresence>
      {draftEntry?.rsvpSettings.enabled && (
        <MotionFlex
          animate={{ opacity: 1 }}
          bg="customgray.bglight"
          borderBottomLeftRadius="md"
          borderBottomRightRadius={activeSidebarPanel ? 'none' : 'md'}
          borderColor="gray.200"
          borderTopWidth="1px"
          exit={{ opacity: 0 }}
          initial={{ opacity: 0 }}
          px="6"
        >
          <RsvpBar entry={draftEntry} />
        </MotionFlex>
      )}
    </AnimatePresence>
  );
};
